/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ item: NonNullable<unknown> }} Coach_Context_AdjustInputs */

const en_us2_coach_context_adjust = /** @type {(inputs: Coach_Context_AdjustInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.item}. Adjust`)
};

const pt_br2_coach_context_adjust = /** @type {(inputs: Coach_Context_AdjustInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.item}. Ajustar`)
};

const es_419_coach_context_adjust = /** @type {(inputs: Coach_Context_AdjustInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.item}. Ajustar`)
};

const pt_pt2_coach_context_adjust = /** @type {(inputs: Coach_Context_AdjustInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.item}. Ajustar`)
};

const fr_fr2_coach_context_adjust = /** @type {(inputs: Coach_Context_AdjustInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.item}. Modifier`)
};

const de_de2_coach_context_adjust = /** @type {(inputs: Coach_Context_AdjustInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.item}. Anpassen`)
};

const it_it2_coach_context_adjust = /** @type {(inputs: Coach_Context_AdjustInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.item}. Modifica`)
};

/**
* | output |
* | --- |
* | "{item}. Adjust" |
*
* @param {Coach_Context_AdjustInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_context_adjust = /** @type {((inputs: Coach_Context_AdjustInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Context_AdjustInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_context_adjust(inputs)
	if (locale === "es-419") return es_419_coach_context_adjust(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_context_adjust(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_context_adjust(inputs)
	if (locale === "de-DE") return de_de2_coach_context_adjust(inputs)
	if (locale === "it-IT") return it_it2_coach_context_adjust(inputs)
	return en_us2_coach_context_adjust(inputs)
});
export { coach_context_adjust as "coach.context_adjust" }